import { Controller } from "@hotwired/stimulus";

export default class RejectDialogController extends Controller {
  static targets = ["dialog"];

  open() {
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }
}
